import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { LEGAL } from "@/lib/site";

export default function Legal({ kind }) {
  const meta = {
    terms: { title: "Terms & Conditions", key: "terms" },
    privacy: { title: "Privacy Policy", key: "privacy" },
    cancellation: { title: "Cancellation Policy", key: "cancellation" },
  }[kind];

  return (
    <div data-testid={`legal-${kind}`} className="py-14 lg:py-20">
      <SEO title={meta.title} description={`D Travel Link ${meta.title} — read before booking your holiday.`} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-skybrand">D Travel Link</p>
        <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{meta.title}</h1>
        <Reveal className="mt-8 space-y-5">
          {LEGAL[meta.key].map((p, i) => (
            <p key={i} className="text-slate-600 leading-relaxed">{p}</p>
          ))}
        </Reveal>
      </div>
    </div>
  );
}
